import React from 'react';
import Helmet from 'react-helmet';

import Img from 'gatsby-image'

import { Constrain } from '../components/@primitives/constrain/index';

import styled from 'react-emotion'
import { SideBySide } from '../components/SideBySide/index';
import { Button } from '../components/@primitives/button/index';

import map from '../components/Logos/map.svg'

const SameDayShipping = styled('section')`
  background-color: #F5F5F5;
  
  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 30px;
    padding:  4vw 0;
    align-items: center;
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  
  .map {
    background-image: url('${map}');
    background-repeat: no-repeat;
    background-size: contain;
    padding-top: 50%;
  }
`

class ProductTemplate extends React.Component {
  render() {

    const products = this.props.data.allMarkdownRemark.edges;

    return (
      <div>
        <Helmet
          title={products[0].node.frontmatter.category}
          meta={[
            {
              name: 'description',
              content: products[0].node.excerpt,
            },
          ]}
        />
        <Constrain>
        {products.map((product, i) => (
            <SideBySide
              key={i}
              align={(i%2 == 0) ? 'right' : null}
              image={product.node.frontmatter.image}
              contain
              heading={product.node.frontmatter.title}
              html={product.node.html}
              downloads={product.node.frontmatter.brochures}
              to={product.node.frontmatter.link ? product.node.frontmatter.link[0].to : null}
              text={product.node.frontmatter.link ? product.node.frontmatter.link[0].text : null}
            />
        ))}
        </Constrain>

        <SameDayShipping>
          <Constrain>
            <div className="grid">
              <div className="map" />
              <div className="copy">
                <h2>Same Day Shipping</h2>
                <p>As the USA Master Distributor for NAF Digester Valves, we offer same day shipping anywhere in the United States. Call us today to see how quickly we can get you what you need!</p>
                <Button
                  to="tel:1-800-284-2283"
                  external
                >
                  Call Us Today
                </Button>
              </div>
            </div>
          </Constrain>
        </SameDayShipping>
      </div>
    );
  }
}

export default ProductTemplate

export const pageQuery = graphql`
  query ProductBySlug($path: String!) {
    allMarkdownRemark(sort: { fields: [frontmatter___title]}, filter: { frontmatter: { path: { eq: $path } } }) {
      edges {
        node {
          excerpt
          html
          frontmatter {
            path
            title
            image
            category
            brochures {
              text
              file
            }
            link {
              text
              to
            }
          }
        }
      }
    }
  }
`
;



// WEBPACK FOOTER //
// ./src/templates/product.js